import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import Moment from 'react-moment';
import CONSTANT from './constant';
import { Skeleton } from 'primereact/skeleton';
import { FormattedNumber } from 'react-intl';

const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
const mentionRegex = /\{\{(.*?)\}\}+/g;
const mentionDetailRegex = /(?<=\{\{)(.*?)(?=\}\})+/g;

export const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)?/gi;

export const CHAT_NAME_COLORS = [
  '#DB2D43',
  '#9F2B68',
  '#3B7A57',
  '#9966CC',
  '#0048BA',
  '#4B6F44',
  '#007FFF',
  '#DA1884',
  '#848482',
  '#2E5894',
  '#3D2B1F',
  '#000000',
  '#54626F',
  '#A57164',
  '#660000',
  '#0087BD',
  '#DE5D83',
  '#004225',
  '#CC5500',
  '#006B3C',
  '#00CC99',
  '#703642',
  '#2A52BE',
  '#E23D28',
  '#6495ED',
  '#006400',
  '#8B008B',
];

export const HUB_OPTIONS: any[] = [
  { label: 'HUB 1A NINH BÌNH - QUẢNG BÌNH', value: 'HUB 1A NINH BÌNH - QUẢNG BÌNH' },
  { label: 'HUB 1B QUẢNG BÌNH - NINH BÌNH', value: 'HUB 1B QUẢNG BÌNH - NINH BÌNH' },
  { label: 'HUB 2A QUẢNG BÌNH - QUẢNG NGÃI', value: 'HUB 2A QUẢNG BÌNH - QUẢNG NGÃI' },
  { label: 'HUB 2B QUẢNG NGÃI - QUẢNG BÌNH', value: 'HUB 2B QUẢNG NGÃI - QUẢNG BÌNH' },
  { label: 'HUB 3A QUẢNG NGÃI - KHÁNH HÒA', value: 'HUB 3A QUẢNG NGÃI - KHÁNH HÒA' },
  { label: 'HUB 3B KHÁNH HÒA - QUẢNG NGÃI', value: 'HUB 3B KHÁNH HÒA - QUẢNG NGÃI' },
  { label: 'HUB 4A KHÁNH HÒA - ĐỒNG NAI', value: 'HUB 4A KHÁNH HÒA - ĐỒNG NAI' },
  { label: 'HUB 4B ĐỒNG NAI - KHÁNH HÒA', value: 'HUB 4B ĐỒNG NAI - KHÁNH HÒA' },
];

export const CURRENT_LOCATION_OPTIONS: any[] = [
  { label: 'NINH BÌNH', value: 'NINH BÌNH' },
  { label: 'QUẢNG BÌNH', value: 'QUẢNG BÌNH' },
  { label: 'QUẢNG NGÃI', value: 'QUẢNG NGÃI' },
  { label: 'KHÁNH HÒA', value: 'KHÁNH HÒA' },
  { label: 'ĐỒNG NAI', value: 'ĐỒNG NAI' },
];

export const HANG_BANG_LAI_OPTIONS: any[] = [
  { label: 'C', value: 'C' },
  { label: 'D', value: 'D' },
  { label: 'E', value: 'E' },
  { label: 'FC', value: 'FC' },
];

export const generateRandomText = (count: number) => {
  let rtn = '';
  for (let i = 0; i < count; i += 1) {
    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
  }
  return rtn;
};

export const getDataInPath = (data: any, field: string) => {
  if (!data) {
    return '';
  }
  const fields = field.split('.');
  if (fields.length === 1) {
    return data[fields[0]];
  } else if (fields.length === 2 && data[fields[0]] && data[fields[0]][fields[1]]) {
    return data[fields[0]][fields[1]];
  } else if (
    fields.length === 3 &&
    data[fields[0]] &&
    data[fields[0]][fields[1]] &&
    data[fields[0]][fields[1]][fields[2]]
  ) {
    return data[fields[0]][fields[1]][fields[2]];
  } else if (
    fields.length === 4 &&
    data[fields[0]] &&
    data[fields[0]][fields[1]] &&
    data[fields[0]][fields[1]][fields[2]] &&
    data[fields[0]][fields[1]][fields[2]][fields[3]]
  ) {
    return data[fields[0]][fields[1]][fields[2]][fields[3]];
  }
};

export const isImage = (item: string) => {
  return item.match(/.(jpg|jpeg|png|gif)$/i);
};

export const buildTagUser = (message: string) => {
  if (mentionRegex.test(message)) {
    const matchedRegex = message.match(mentionRegex);
    if (matchedRegex && !isEmpty(matchedRegex)) {
      for (let i = 0; i < matchedRegex.length; i++) {
        const matchedData = matchedRegex[i].match(mentionDetailRegex);
        if (matchedData && matchedData.length > 0) {
          const userIDs = matchedData[0].split('@');
          if (userIDs.length > 1) {
            message = message.replace(matchedRegex[i], `<a href="#">@${userIDs[1]}</a>`);
          }
        }
      }
    }
  }
  return message;
};

export const formatChatTime = (date: any) => {
  if (moment(Number(date)).get('date') === moment().get('date')) {
    return `---------- ${moment(Number(date)).format('HH:mm')}, Hôm nay ----------`;
  }

  if (moment(Number(date)).get('date') === moment().subtract(1, 'day').get('date')) {
    return `---------- ${moment(Number(date)).format('HH:mm')}, Hôm qua ----------`;
  }

  return `---------- ${moment(Number(date)).format('HH:mm, DD/MM/YYYY')} ----------`;
};

export const trimLastMessage = (message: string) => {
  return message.length > 40 ? message.substring(0, 40) + '...' : message;
};

export const formatSystemAdv = (item: any) => {
  try {
    const messageObj = item.message.split('\n');
    return (
      <div className="system-adv-content">
        <p className="text-bold">{messageObj[0]}</p>
        <p>{messageObj[1]}</p>
        <p>{messageObj[2]}</p>
        <p>{messageObj[3]}</p>
        <p>{messageObj[4]}</p>
        <p>{messageObj[5]}</p>
        <p>
          <small className="text-center d-block">{formatChatTime(item.created_at)}</small>
        </p>
      </div>
    );
  } catch (e) {
    return <div className="system-adv-content">{item.message}</div>;
  }
};

export const formatChatMessageTime = (date: any) => {
  if (moment(Number(date)).get('date') === moment().get('date')) {
    return moment(Number(date)).format('HH:mm');
  }

  if (moment(Number(date)).get('date') === moment().subtract(1, 'day').get('date')) {
    return `Hôm qua, ${moment(Number(date)).format('HH:mm')}`;
  }

  return moment(Number(date)).format('DD/MM, HH:mm');
};

export const formatDurationToTimeFull = (time: any) => {
  const second = moment().diff(moment(time), 'seconds');
  if (second < 60) {
    return `${second} giây`;
  } else if (second < 3600) {
    return `${Math.floor(second / 60)} phút`;
  } else if (second < 86400) {
    return `${Math.floor(second / 3600)} giờ`;
  } else {
    return `${Math.floor(second / 86400)} ngày`;
  }
};

export const autoConvertToHyperlink = (text: string) => {
  const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  return text.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
};

export const longDateFormat = (date: any) => {
  return date ? <Moment date={date} format={CONSTANT.DATE_FORMAT.LONG} /> : <></>;
};

export const getDarkColor = () => {
  return CHAT_NAME_COLORS[Math.floor(Math.random() * CHAT_NAME_COLORS.length)];
};

export const loadingTemplate = (options: any) => {
  return (
    <div className="flex align-items-center" style={{ height: '17px', flexGrow: '1', overflow: 'hidden' }}>
      <Skeleton width={options.cellEven ? (options.field === 'year' ? '30%' : '40%') : '60%'} height="1rem" />
    </div>
  );
};

export const indexTemplate = (data: any, col: any) => {
  return col.rowIndex + 1;
};

export const isLogged = (user: any) => {
  return user && user.token;
};

export const longDateTemplate = (rowData: any, column: any) => {
  return rowData && rowData[column.field] && <Moment date={rowData[column.field]} format={CONSTANT.DATE_FORMAT.LONG} />;
};

export const shortDateTemplate = (rowData: any, column: any) => {
  return (
    rowData && rowData[column.field] && <Moment date={rowData[column.field]} format={CONSTANT.DATE_FORMAT.SHORT} />
  );
};

export const formatNumberTemplate = (rowData: any, col: any) => {
  return rowData && rowData[col.field] > 0 ? (
    <>
      <FormattedNumber
        value={Number(rowData[col.field])}
        maximumFractionDigits={col.field === 'percent' ? 3 : 0}
        minimumFractionDigits={0}
      />
      {col.field === 'percent' && <span> %</span>}
    </>
  ) : (
    <></>
  );
};

export const formatTimeDuration = (beginTime: any, endTime: any) => {
  const second = moment(endTime).diff(moment(beginTime), 'seconds');
  if (second < 60) {
    return `${second}s`;
  } else if (second < 3600) {
    return `${Math.floor(second / 60)}p ${second % 60}s`;
  } else if (second < 86400) {
    const minute = Math.floor(second % 3600);
    return `${Math.floor(second / 3600)}g ${Math.floor(minute / 60)}p ${minute % 60}s`;
  } else {
    const hour = Math.floor(second % 86400);
    const minute = Math.floor(hour % 3600);
    return `${Math.floor(second / 86400)}ng ${Math.floor(hour / 3600)}g ${Math.floor(minute / 60)}p ${minute % 60}s`;
  }
};

export const formatBreakLineTemplate = (rowData: any, col: any) => {
  const data = getDataInPath(rowData, col.field);

  return (
    data &&
    `${data}`.split(',').map((item: any, index: number) => {
      return (
        <span key={index}>
          {item}
          <br />
        </span>
      );
    })
  );
};

export const isSystemAdmin = (user: any): boolean => {
  return user?.system_roles?.includes(CONSTANT.SYSTEM_ROLES.QUAN_TRI_HE_THONG);
};

export const hasPermission = (user: any, permission: string) => {
  return (
    isSystemAdmin(user) || user?.system_roles?.includes(permission) || user?.management_roles?.includes(permission)
  );
};
